import { useState } from "react";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Mail, MapPin, Phone } from "lucide-react";

const Contact = () => {
  const [loading, setLoading] = useState(false);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      toast.success("Thank you — we'll be in touch shortly.");
      (e.target as HTMLFormElement).reset();
      setLoading(false);
    }, 700);
  };

  return (
    <>
      <PageHeader
        eyebrow="Get in touch"
        title="Let's build resilience together."
        subtitle="Whether you're a partner, donor, journalist, or community member — we'd love to hear from you."
      />

      <section className="section-padding">
        <div className="container-wide grid gap-14 md:grid-cols-5">

          {/* Info */}
          <div className="md:col-span-2">
            <h2 className="font-serif text-2xl font-semibold text-primary">HEADQUARTERS</h2>
            <p></p>
           <h2 className="font-serif text-2xl font-semibold text-blue-600">
               Contact Person: Ibrahim Hassan
           </h2>
            <p className="mt-3 text-muted-foreground">
              We respond to most inquiries within two business days.
            </p>
            <ul className="mt-8 space-y-5">
              <li className="flex gap-4">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-md bg-primary/10 text-primary">
                  <MapPin className="h-5 w-5" />
                </span>
                <div>
                  <p className="font-medium text-foreground">Office</p>
                  <p className="text-sm text-muted-foreground">Moyale, Ethiopia</p>
                </div>
              </li>
              <li className="flex gap-4">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-md bg-primary/10 text-primary">
                  <Mail className="h-5 w-5" />
                </span>
                <div>
                  <p className="font-medium text-foreground">Email</p>
                  <p className="text-sm text-muted-foreground">info@credohorn.org</p>
                </div>
              </li>
              <li className="flex gap-4">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-md bg-primary/10 text-primary">
                  <Phone className="h-5 w-5" />
                </span>
                <div>
                  <p className="font-medium text-foreground">Phone</p>
                  <p className="text-sm text-muted-foreground">+251990415466</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Form */}
          <form
            onSubmit={onSubmit}
            className="rounded-lg border border-border bg-card p-8 shadow-[var(--shadow-card)] md:col-span-3"
          >
            <div className="grid gap-5 sm:grid-cols-2">
              <div>
                <Label htmlFor="name">Full name</Label>
                <Input id="name" required className="mt-2" placeholder="Your Name" />
              </div>
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required className="mt-2" placeholder="you@email.com" />
              </div>
            </div>
            <div className="mt-5">
              <Label htmlFor="subject">Subject</Label>
              <Input id="subject" required className="mt-2" placeholder="How can we help?" />
            </div>
            <div className="mt-5">
              <Label htmlFor="message">Message</Label>
              <Textarea id="message" required rows={6} className="mt-2" placeholder="Tell us a bit more…" />
            </div>
            <Button
              type="submit"
              size="lg"
              disabled={loading}
              className="mt-6 w-full bg-accent text-accent-foreground hover:bg-accent/90 sm:w-auto"
            >
              {loading ? "Sending…" : "Send message"}
            </Button>
          </form>
        </div>
      </section>
    </>
  );
};

export default Contact;
